import React from 'react';
import { LineChart, Shield, BookOpen, Users, Globe, Award } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';

const iconMap = {
  LineChart,
  Shield,
  BookOpen,
  Users,
  Globe,
  Award
};

const WhyChoose = () => {
  return (
    <section className="py-16 sm:py-20 bg-white relative overflow-hidden">
      {/* Background Image - Classroom */}
      <div className="absolute top-0 left-0 w-full h-64 opacity-5">
        <img 
          src="/images/academy/classroom.jpg" 
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-green-600">Stocks Vision Academy?</span>
          </h2>
          <p className="text-lg text-gray-600">
            What makes us different from other stock market training institutes in Bhopal
          </p>
        </div>

        {/* Features Grid */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseUs.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.title}
                className="group bg-white border-2 border-gray-200 hover:border-green-600 rounded-xl p-6 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-green-100 group-hover:bg-green-600 rounded-xl flex items-center justify-center mb-4 transition-colors duration-300">
                  <IconComponent className="h-7 w-7 text-green-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Disclaimer Box */}
        <div className="max-w-4xl mx-auto mt-12">
          <div className="bg-yellow-50 border-l-4 border-yellow-500 rounded-lg p-6">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-bold">!</span>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Important Disclaimer</h4>
                <p className="text-gray-700">
                  We do <span className="font-semibold">NOT guarantee profits or fixed returns</span>. Stock market trading involves risk, 
                  and past performance does not guarantee future results. Our focus is to equip you with skills, strategies, 
                  and risk management techniques to make informed trading decisions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
